import React from "react";
import { useQuery } from "react-query";
import { Container } from "reactstrap";
import { HeaderSection } from "../../components/shared/HeaderSection";
import { CardTouristic } from "../../components/tourism/CardTouristic";

import ROUTES from "../../routes/routes";
import { getTouristRoutes } from "../../services/tourismService";

const TouristRoutes = () => {
  const colorRoutes = "#1CBB20";
  const { isLoading, isError, data, isFetching } = useQuery(
    "tourist-routes",
    getTouristRoutes
  );

  if (isLoading) return <p>Cargando</p>;
  if (isFetching) return <p>Loading feaching...</p>;
  if (isError) return <p>error</p>;

  return (
    <>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorRoutes}
      />
      <Container>
        <h3 className="subheader-main" style={{ borderColor: "#1BADE1" }}>
          Rutas Turísticas
        </h3>

        <CardTouristic
          data={data}
          routeDetail={ROUTES.TROUTE_DETAIL}
          bgBtnColor={colorRoutes}
        />
      </Container>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorRoutes}
      />
    </>
  );
};

export default TouristRoutes;
